<div
  class="otp-input-wrapper wrapper"
  id="c_{{ componentKey }}"
  *ngIf="otpForm?.controls"
>
  <form [formGroup]="otpForm">
    <input
      [pattern]="config.allowNumbersOnly ? '\\d*' : ''"
      [type]="inputType"
      maxlength="1"
      class="otp-input"
      autocomplete="off"
      *ngFor="let item of otpForm?.controls | keys; let i = index"
      [formControlName]="item"
      #inp
      id="otp_{{ i }}_{{ componentKey }}"
      (keyup)="onKeyUp($event, i)"
      (input)="onInput($event)"
      (keydown)="onKeyDown($event)"
    />
  </form>
</div>
